import { ArrowUpRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function DashboardCard({ title, description, icon: Icon, to, accent = "blue", testId, delay = 0 }) {
  const navigate = useNavigate();

  const accentMap = {
    blue: { bg: "bg-blue-50", text: "text-blue-700", ring: "group-hover:ring-blue-300" },
    rose: { bg: "bg-rose-50", text: "text-rose-700", ring: "group-hover:ring-rose-300" },
    emerald: { bg: "bg-emerald-50", text: "text-emerald-700", ring: "group-hover:ring-emerald-300" },
    amber: { bg: "bg-amber-50", text: "text-amber-700", ring: "group-hover:ring-amber-300" },
    indigo: { bg: "bg-indigo-50", text: "text-indigo-700", ring: "group-hover:ring-indigo-300" },
  };
  const a = accentMap[accent] || accentMap.blue;

  return (
    <button
      onClick={() => navigate(to)}
      data-testid={testId}
      className={`group anim-fade-up text-left bg-white rounded-2xl ring-1 ring-slate-200 ${a.ring} p-7 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 flex flex-col gap-4 min-h-[200px]`}
      style={{ animationDelay: `${delay}ms` }}
    >
      <div className="flex items-start justify-between">
        <div className={`h-12 w-12 rounded-xl ${a.bg} ${a.text} flex items-center justify-center`}>
          <Icon className="h-6 w-6" strokeWidth={1.8} />
        </div>
        <ArrowUpRight className="h-5 w-5 text-slate-300 group-hover:text-slate-700 transition" />
      </div>
      <div>
        <h3 className="font-display text-xl font-semibold text-slate-900 tracking-tight">{title}</h3>
        <p className="text-sm text-slate-500 mt-2 leading-relaxed">{description}</p>
      </div>
    </button>
  );
}
